import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3255b1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold nft-promo-note m-discount-inactive"
}
const _hoisted_2 = {
  key: 1,
  class: "manifold nft-promo-note m-discount-inactive"
}
const _hoisted_3 = { class: "icon-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "promo-active" }
const _hoisted_7 = {
  key: 2,
  class: "manifold nft-promo-note m-discount-inactive-expired"
}
const _hoisted_8 = { class: "icon-container" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "promo-expired" }, [
  /*#__PURE__*/_createElementVNode("span", null, "NFT Discount Ended"),
  /*#__PURE__*/_createElementVNode("span", null, "Please stay tuned for the next drop!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_screen = _resolveComponent("loading-screen")!

  return (!_ctx.countdownLoaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_loading_screen)
      ]))
    : (_ctx.activeCountdown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.customStarImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.customStarImage
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.starFavorite
                }, null, 8, _hoisted_5))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.activeCountdownText), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.getters.countdown.days) + ":" + _toDisplayString(_ctx.getters.countdown.hours) + ":" + _toDisplayString(_ctx.getters.countdown.minutes) + ":" + _toDisplayString(_ctx.getters.countdown.seconds), 1)
          ])
        ]))
      : (_ctx.expired)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.customStarImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.customStarImage
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _ctx.starFavorite
                  }, null, 8, _hoisted_10))
            ]),
            _hoisted_11
          ]))
        : _createCommentVNode("", true)
}